import { Radio } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#050B14] border-t border-[#0066FF]/15 py-14" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          <div className="max-w-sm">
            <div className="flex items-center gap-2 mb-4">
              <Radio className="h-6 w-6 text-[#0066FF]" strokeWidth={2.5} />
              <div className="font-display text-lg tracking-wide">
                THE OTHER SIDE OF <span className="text-[#0066FF]">BLUE</span>
              </div>
            </div>
            <p className="text-sm text-[#94A3B8] leading-relaxed">
              A St. Louis podcast that bridges the gap between law enforcement and the community.
              Built on truth. Driven by respect. Focused on solutions.
            </p>
            <div className="mt-5 font-mono2 text-xs tracking-[0.3em] uppercase text-[#FF6B00]">
              Change Starts With Us.
            </div>
          </div>

          <div className="grid grid-cols-2 gap-10">
            <div>
              <div className="font-cond font-bold uppercase text-sm text-white mb-3">Explore</div>
              <ul className="space-y-2 text-sm text-[#94A3B8]">
                <li><a href="#episodes" className="hover:text-[#0066FF]">Episodes</a></li>
                <li><a href="#videos" className="hover:text-[#0066FF]">Videos</a></li>
                <li><a href="#gallery" className="hover:text-[#0066FF]">Gallery</a></li>
                <li><a href="#voices" className="hover:text-[#0066FF]">Citizen Voices</a></li>
              </ul>
            </div>
            <div>
              <div className="font-cond font-bold uppercase text-sm text-white mb-3">Get Involved</div>
              <ul className="space-y-2 text-sm text-[#94A3B8]">
                <li><a href="#live-mic" className="hover:text-[#0066FF]">Grab the Mic</a></li>
                <li><a href="#subscribe" className="hover:text-[#0066FF]">Subscribe</a></li>
                <li><a href="/login" className="hover:text-[#FF6B00]">Admin Access</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#0066FF]/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#94A3B8] font-mono2 uppercase tracking-widest">
          <span>Real Stories. Real People. Real Change.</span>
          <span>&copy; {new Date().getFullYear()} The Other Side of Blue — St. Louis</span>
        </div>
      </div>
    </footer>
  );
}
